window.easterEggsSettings = {
  general: {
    enable: true,
    defaultEggImage: '//www.blackcraftcult.com/cdn/shop/files/Default_Egg.png?v=1744501009&width=480',
    monsterEggImage: '//www.blackcraftcult.com/cdn/shop/files/Monster_Egg.png?v=1744501011&width=480',
  },
  header: {
    enable: true,
    discountCode: 'BY2CJ9BDN2J2',
    discountType: '10% Off',
  },
  dropdownMenu: {
    enable: true,
    discountCode: 'BY2CJ9BDN2J2',
    discountType: '10% Off',
  },
  searchForm: {
    enable: true,
    discountCode: 'MC8VD2DHP0CN',
    discountType: '20% Off',
  },
  footer: {
    enable: true,
    discountCode: 'MC8VD2DHP0CN',
    discountType: '20% Off',
  },
  collections: {
    enable: true,
    discountCode: 'MC8VD2DHP0CN',
    discountType: '20% Off',
  },
  productHeart: {
    enable: true,
    discountCode: 'B5QHD1N9RHF3',
    discountType: '30% Off',
  },
  productImages: {
    enable: false,
    discountCode: 'A1R1ZMY8JJ18',
    discountType: 'A $100 Gift Code',
  },
  sizeGuides: {
    enable: true,
    discountCode: 'MC8VD2DHP0CN',
    discountType: '20% Off',
  },
  aboutPage: {
    enable: true,
    discountCode: 'MC8VD2DHP0CN',
    discountType: '20% Off',
  },
  wishlistPage: {
    enable: true,
    discountCode: 'BY2CJ9BDN2J2',
    discountType: '10% Off',
  },
  termsOfServicePage: {
    enable: true,
    discountCode: 'B5QHD1N9RHF3',
    discountType: '30% Off',
  },
  privacyPolicyPage: {
    enable: true,
    discountCode: 'B5QHD1N9RHF3',
    discountType: '30% Off',
  },
  refundPolicyPage: {
    enable: true,
    discountCode: 'B5QHD1N9RHF3',
    discountType: '30% Off',
  }
}